import { Container } from 'inversify'
import AbstractConnect from '../../../../framework/src/connect/ajax/AbstractConnect'
import { JokerWinConnect } from '../ajax/Connector'
import { IJokerWinBanner } from '../interfaces/JokerWinBanner.interface'
import { JokerWinBanner } from '../JokerWinBanner'
import { JokerBonusWinNotifier } from '../ajax/WinNotifier'
import { LevelInfo } from '../ajax/LevelInfo'
import { ITextStyle } from 'pixi.js-legacy'
import { TranslateService } from '../TranslateService'
import { JokerBonusOpenTickets } from '../ajax/OpenTickets'
import JOKER_BONUS_IDENTIFIERS from './identifiers'
import { JokerWinThemes } from '../ajax/Themes'
import { CurrencyConvert } from '../ajax/CurrencyConvert'

export function defineJokerWinBanner(container: Container): void {
	container
		.bind(JOKER_BONUS_IDENTIFIERS.JOKER_BONUS_WIN_NOTIFIER)
		.to(JokerBonusWinNotifier)
		.inSingletonScope()
	container
		.bind<AbstractConnect>(JOKER_BONUS_IDENTIFIERS.JOKER_WIN_CONNECT_IDENTIFIER)
		.to(JokerWinConnect)
		.inSingletonScope()
	container
		.bind<AbstractConnect>(
			JOKER_BONUS_IDENTIFIERS.JOKER_WIN_LEVEL_INFO_CONNECT_IDENTIFIER
		)
		.to(LevelInfo)
		.inSingletonScope()
	container
		.bind<AbstractConnect>(
			JOKER_BONUS_IDENTIFIERS.JOKER_BONUS_UNCLAIMED_TICKETS
		)
		.to(JokerBonusOpenTickets)
		.inSingletonScope()
	container
		.bind<IJokerWinBanner>(JOKER_BONUS_IDENTIFIERS.JOKER_WIN_BANNER_IDENTIFIER)
		.to(JokerWinBanner)
		.inSingletonScope()
	container
		.bind<TranslateService>(
			JOKER_BONUS_IDENTIFIERS.JOKER_BONUS_TRANSLATE_SERVICE
		)
		.to(TranslateService)
		.inSingletonScope()
	container.bind(JOKER_BONUS_IDENTIFIERS.JOKER_BONUS_THEMES).to(JokerWinThemes)

	container
		.bind<AbstractConnect>(JOKER_BONUS_IDENTIFIERS.JOKER_BONUS_CURRENCY_CONVERT)
		.to(CurrencyConvert)
		.inSingletonScope()
}

export const textStyle: Partial<ITextStyle> = {
	fillGradientStops: [0.2, 0.5, 0.8],
	fillGradientType: 0,
	dropShadowBlur: 3,
	dropShadowColor: 0x000000,
	dropShadowAngle: 1,
	dropShadowDistance: 4,
	dropShadow: false,
	miterLimit: 9,
	strokeThickness: 0,
	fontVariant: 'small-caps',
}
